import uiNuggetCustomerForm from './customer-form/index.vue'
import uiNuggetStageStatusForm from './stage-status-form/index.vue'
import uiNuggetResponsibleForm from './responsible-form/index.vue'
import uiNuggetHistoricalForm from './historical-form/index.vue'
import uiNuggetProductForm from './nugget-product-form/index.vue'
import uiNuggetActionsSageStatus from './actions-stage-stauts-form/index.vue'

export {
	uiNuggetCustomerForm,
	uiNuggetStageStatusForm,
	uiNuggetResponsibleForm,
	uiNuggetHistoricalForm,
	uiNuggetProductForm,
    uiNuggetActionsSageStatus,
}
